import { css } from '@emotion/react';

const grid = css`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

const maxWidthAndCenter = css`
  max-width: 90rem;
  width: 100%;
  margin: 0 auto;
`;

const h2 = css`
  text-align: center;
  font-size: 2.25rem;
  font-weight: 900;
  text-transform: uppercase;
`;

export { grid, maxWidthAndCenter, h2 };
